export type CafOverrideOption = {
    id: number;
    isBase: boolean;
};

export type CafOverrideProduct = {
    MouldingID: number;
    Mat1_ID: number;
    Mat2_ID: number;
    mouldings: CafOverrideOption[] | null | undefined;
    caf_mat1: CafOverrideOption[] | null | undefined;
    caf_mat2: CafOverrideOption[] | null | undefined;
};

export type CafOverrideIds = {
    oid_m0: number;
    oid_m1: number;
    oid_m2: number;
};

const applyListOverride = (options: CafOverrideOption[] | null | undefined, oid: number): number | undefined => {
    if (!(oid > 0) || !options || !options.some(option => option.id === oid)) {
        return undefined;
    }

    for (let i = 0; i < options.length; i++) {
        options[i].isBase = options[i].id === oid;
    }

    return oid;
};

// CAF URL/session overrides (mmid/pmid/smid → __oid_m0/m1/m2). Each id writes only
// its own baseline and isBase flags, and only when it exists in that list.
export const applyCafOptionOverrides = (prod: CafOverrideProduct, oids: CafOverrideIds): void => {
    const mouldingId = applyListOverride(prod.mouldings, oids.oid_m0);
    if (mouldingId !== undefined) {
        prod.MouldingID = mouldingId;
    }

    const mat1Id = applyListOverride(prod.caf_mat1, oids.oid_m1);
    if (mat1Id !== undefined) {
        prod.Mat1_ID = mat1Id;
    }

    const mat2Id = applyListOverride(prod.caf_mat2, oids.oid_m2);
    if (mat2Id !== undefined) {
        prod.Mat2_ID = mat2Id;
    }
};
